
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Musical Rejuvenation</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm classic-conclave section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Musical<span > Rejuvenation</span></h2>
            <p>Music has been an integral part of human life for centuries, serving various purposes
                such as entertainment.</p>
        </div>
        <div class="row text-justify">
            <div class="widget_title inner-title">
                <h4>Musical Rejuvenation</h4>
            </div>
            <p>
                Music has been an integral part of human life for centuries, serving various purposes
                such as entertainment, cultural expression, and emotional regulation. From lullabies to
                anthems, music has the ability to evoke strong emotions and memories, create social
                connections, and improve mental and physical health. Its role in human life is
                undeniable and continues to evolve with time.
            </p>
            <p>
                G H Raisoni Sports and Cultural Foundation has been organizing a Musical Rejuvenation
                program across various districts, particularly after the COVID-19 era. The program aims
                to provide a much-needed respite to people who have been affected by the pandemic&#39;s
                mental and emotional toll. The foundation believes that music has the power to heal and
                rejuvenate people, and thus, has designed the program to lift people&#39;s spirits through
                the medium of music.

            </p>

        </div>
        <div class="widget_title inner-title">
            <h4>PROGRAMS TILL DATE</h4>
        </div>
        <div class="table-responsive">
            <table class="table table-hover table-striped table-effect--primary shadow-soft">
                <thead class="head-table">
                    <tr>
                        <th class="text-no">Sr. No.</th>
                        <th>Date</th>
                        <th>Event</th>
                    </tr>
                </thead>
                <tbody class="tb-hover cust_ser_num">
                    <tr>
                        <td></td>
                        <td>31<sup>th</sup> May 2023 </td>
                        <td>Unforgettable KK: A Musical Tribute to the Legend</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>26<sup>th</sup> May 2023 </td>
                        <td>A Musical Tribute to Bharat Ratna - Bhandara</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>05<sup>th</sup> May 2023 </td>
                        <td>A Musical Tribute to Bharat Ratna - Wardha</td>
                    </tr>

                    <tr>
                        <td></td>
                        <td>29<sup>th</sup> April 2023 </td>
                        <td>A Musical Tribute to Bharat Ratna - Chandrapur</td>
                    </tr>

                    <tr>
                        <td></td>
                        <td>25<sup>th</sup> February 2022 </td>
                        <td>A Musical Tribute to Lata Mangeshkar - Nagpur</td>
                    </tr>

                </tbody>
            </table>
        </div>
        <div class="row row-cols-1 row-cols-lg-3 mt-5">
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/lata-mangeshkar-betul-event" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-mangeshkar.webp"
                                alt="Naad Ninaad" title="Naad Ninaad"></a>

                        <h4>A Musical Tribute to Bharat Ratna - Betul</h4>
                        <h5> 6<sup>th</sup> August 2023 </h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/lata-mangeshkar-chhindwara-event" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-mangeshkar.webp"
                                alt="Naad Ninaad" title="Naad Ninaad"></a>

                        <h4>A Musical Tribute to Bharat Ratna - Chhindwara</h4>
                        <h5>28<sup>th</sup>July 2023 </h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/lata-mangeshkar-akola-event" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-mangeshkar.webp"
                                alt="Naad Ninaad" title="Naad Ninaad"></a>

                        <h4>A Musical Tribute to Bharat Ratna - Akola</h4>
                        <h5>9<sup>th</sup>July 2023 </h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/lata-mangeshkar-yavatmal-event" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-mangeshkar.webp"
                                alt="Naad Ninaad" title="Naad Ninaad"></a>

                        <h4>A Musical Tribute to Bharat Ratna - Yavatmal</h4>
                        <h5>23<sup>rd</sup>July 2023 </h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/unforgettable-kk" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kk.webp"
                                alt="unforgettable kk" title="Unforgettable Kk"></a>

                        <h4>Unforgettable KK: A Musical Tribute to the Legend</h4>
                        <h5> 31<sup>st</sup>
                            May 2023 </h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/lata-mageshkar-bhandara-event" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-mangeshkar.webp"
                                alt="Naad Ninaad" title="Naad Ninaad"></a>

                        <h4>A Musical Tribute to Bharat Ratna - Bhandara</h4>
                        <h5> 26<sup>th</sup> May 2023 </h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/lata-mageshkar-wardha-event" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-mangeshkar.webp"
                                alt="Naad Ninaad" title="Naad Ninaad"></a>

                        <h4>A Musical Tribute to Bharat Ratna - Wardha</h4>
                        <h5>05<sup>th</sup> May 2023 </h5>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/lata-mageshkar-chandrapur-event" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-mangeshkar.webp"
                                alt="Naad Ninaad" title="Naad Ninaad"></a>

                        <h4>A Musical Tribute to Bharat Ratna - Chandrapur</h4>
                        <h5>29<sup>th</sup>April 2023 </h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/lata-mangeshkar" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-mangeshkar.webp"
                                alt="Lata Mangeshkar" title="Lata Mangeshkar"></a>
                        <h4>A Musical Tribute to Lata Mangeshkar - Nagpur</h4>
                        <h5>25<sup>th</sup> February 2022</h5>
                    </div>
                </div>
            </div>


        </div>
    </div>
</section>
